import React from 'react'
import { Row, Col } from 'reactstrap'
import oxxoImage from '../../../assets/images/oxxo.png'

const PaymentMethods = ({
  setPaymentMethod,
  paymentMethodSelected,
}) => {
  return (
    <React.Fragment>
      <div className="cart-card">
        <Row>
          <h3 className="cart-card-title">Selecciona método de pago</h3>
        </Row>
        <Row>
          <Col sm="12"
            className="cart-card-font"
            style={{ alignSelf: 'center', cursor: 'pointer' }}
            onClick={() => { 
                window.analytics.track(`Payment Method Selected`, { method: `Online payment` })
                setPaymentMethod('PAGO_EN_LINEA') 
            }}
          >
            {paymentMethodSelected === 'PAGO_EN_LINEA' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle font-size-24" style={{ color: 'green' }}></i>
              </div>
            )}
            {paymentMethodSelected !== 'PAGO_EN_LINEA' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle-outline font-size-24"></i>
              </div>
            )}
            <div style={{ display: 'flex' }}>
              <i
                className="mdi mdi-credit-card-multiple-outline font-size-24"
                style={{ marginRight: '10px', marginTop: '5px', color: 'royalblue' }}
              >
              </i>
              <div style={{ display: 'block' }}>
                <div className="cart-user-address-card-subtitle">
                  Pago en línea
                </div>
                <div style={{ alignSelf: 'center', fontWeight: 300 }}>
                  Tarjeta de débito o crédito
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            borderBottom: '.1rem solid #cccccc'
          }}
        >
        </div>
        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12"
            className="cart-card-font"
            style={{ alignSelf: 'center', cursor: 'pointer' }}
            onClick={() => { 
                window.analytics.track(`Payment Method Selected`, { method: `Bank Deposit / Transfer` })
                setPaymentMethod('DEPOSITO')
            }}
          >
            {paymentMethodSelected === 'DEPOSITO' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle font-size-24" style={{ color: 'green' }}></i>
              </div>
            )}
            {paymentMethodSelected !== 'DEPOSITO' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle-outline font-size-24"></i>
              </div>
            )}
            <div style={{ display: 'flex' }}>
              <i
                className="mdi mdi-cash-usd font-size-24"
                style={{ marginRight: '10px', marginTop: '5px', color: 'green' }}
              >
              </i>
              <div style={{ display: 'block' }}>
                <div className="cart-user-address-card-subtitle">
                  Pago en banco
                </div>
                <div style={{ alignSelf: 'center', fontWeight: 300 }}>
                  Depósito en ventanilla y/o transferencia bancaria
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            borderBottom: '.1rem solid #cccccc'
          }}
        >
        </div>
        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12"
            className="cart-card-font"
            style={{ alignSelf: 'center', cursor: 'pointer' }}
            onClick={() => { 
                window.analytics.track(`Payment Method Selected`, { method: `OXXO` })
                setPaymentMethod('OXXO')
            }}
          >
            {paymentMethodSelected === 'OXXO' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle font-size-24" style={{ color: 'green' }}></i>
              </div>
            )}
            {paymentMethodSelected !== 'OXXO' && (
              <div className="cart-payment-card-check">
                <i className="mdi mdi-check-circle-outline font-size-24"></i>
              </div>
            )}
            <div style={{ display: 'flex' }}>
              <img
                style={{ width: '27px', height: '22px', marginRight: '10px', marginTop: '12px' }}
                src={oxxoImage}
                alt="Oxxo"
              />
              <div style={{ display: 'block' }}>
                <div className="cart-user-address-card-subtitle">
                  Oxxo
                </div>
                <div style={{ alignSelf: 'center', fontWeight: 300 }}>
                  Paga en tu Oxxo más cercano
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default PaymentMethods
